import Axios, { AxiosRequestConfig } from 'axios';

import { API_URL, API_DEV_URL } from '@/config';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';

function authRequestInterceptor(config: AxiosRequestConfig) {
  const token = storage.getToken();
  config.headers.authorization = token ? `${token}` : '';
  config.headers.Accept = 'application/json';
  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
});
export const axios2 = Axios.create({
  baseURL: API_DEV_URL,
});
axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;

    // Only show notification for errors
    useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'Error',
      message,
    });

    // Reject only if the status code is 500
    if (error.response?.status === 500) {
      return Promise.reject(error);
    }

    // Otherwise, continue with the flow
    return Promise.resolve(error.response);
  }
);

axios2.interceptors.request.use(authRequestInterceptor);
axios2.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message =
      error?.response?.data?.status_message || error.response?.data?.message || error.message;

    // Only show notification for errors
    useNotificationStore.getState().addNotification({
      type: 'error',
      title: 'Error',
      message,
    });

    // Reject only if the status code is 500
    if (error.response?.status >= 500) {
      return Promise.reject(error);
    }

    // Otherwise, continue with the flow
    return Promise.resolve(error.response);
  }
);
